// Five-step ramps: line, shadow, mid, light, highlight. Shadows lean cool
// (toward violet/blue) and highlights lean warm, so shading reads as light
// rather than just "darker/lighter" of one hue.
import type { Ramp } from './engine.ts';

export const R = {
  // fur / skin
  frostFur: ['#1f2758', '#41589c', '#6b8ccc', '#a3c2ec', '#e2f1ff'],
  snowFur: ['#4b4f7e', '#a2a8cc', '#d6dcef', '#f2f4fb', '#ffffff'],
  slateFur: ['#191a36', '#343a68', '#4f5a92', '#7487bd', '#a9bee0'],
  charcoal: ['#110d1c', '#2a2340', '#433a5e', '#655a86', '#988cb6'],
  foxWhite: ['#6b5068', '#c2adc0', '#ece0e8', '#fffafb', '#ffffff'],
  cream: ['#7a5a48', '#c9a785', '#ecd6b2', '#fff1d8', '#fffcf2'],
  fawn: ['#5a3020', '#a0603a', '#d08e55', '#f0b878', '#ffe0a8'],
  brown: ['#2e1a1a', '#5a3428', '#83503a', '#ad7550', '#d6a070'],
  oniRed: ['#4a0f22', '#9a2236', '#d0403c', '#f27258', '#ffb894'],
  pink: ['#6e2448', '#c25078', '#ec88a4', '#ffbccc', '#ffe6ee'],
  // materials
  ice: ['#1b4f86', '#3596d2', '#74d0f2', '#bdf0fc', '#ffffff'],
  horn: ['#4a3a34', '#8f7660', '#cdb48c', '#efe0bc', '#fffaf0'],
  claw: ['#1a1626', '#3a3448', '#5c5470', '#8a82a2', '#c6c0dc'],
  iron: ['#171a26', '#343a4e', '#58607a', '#8a93ad', '#c9d0e2'],
  gold: ['#6a3810', '#b26e1c', '#e5a632', '#ffd468', '#fff3c0'],
  bronze: ['#4a2210', '#8a4a1e', '#c27a34', '#e6a85a', '#ffd89a'],
  ember: ['#6a160e', '#c0341a', '#f06a28', '#ffa83e', '#ffe484'],
  foxfire: ['#7a1a2a', '#e04838', '#ff8a3a', '#ffc85a', '#fff2b0'],
  spirit: ['#0e4a5a', '#1f93a8', '#4fd0d8', '#a6f4ee', '#f0fffc'],
  violet: ['#3a1764', '#7a3cc0', '#ae6cf4', '#dcb4ff', '#f6ecff'],
  leaf: ['#16361e', '#2f6a34', '#4f9a42', '#86c45a', '#c8ec8a'],
  marble: ['#5a5470', '#a8a4bc', '#dcd8e6', '#f6f4fa', '#ffffff'],
  aegean: ['#122a5a', '#22549e', '#3a86d0', '#74bcec', '#c4ecff'],
  terracotta: ['#4e1a14', '#9a3a22', '#cc6236', '#ec9358', '#ffc88e'],
  sunGold: ['#7a3a1a', '#d07a28', '#f6b640', '#ffe07a', '#fffbe0'],
  dusk: ['#1a1030', '#3a2458', '#5c3a80', '#8a62aa', '#c6a2d8'],
  stone: ['#1e1c2a', '#3e3c52', '#615f78', '#8e8ca6', '#c4c2d8'],
  rust: ['#2a120c', '#5a2a18', '#8a4826', '#b8703e', '#e0a070'],
  ghoul: ['#1a2a38', '#3a5a6a', '#6a8e98', '#a2c4c4', '#dcf2ee'],
  leather: ['#22140e', '#46281a', '#6a4026', '#90603a', '#b88a5a'],
  raven: ['#0c0a14', '#1c1828', '#2e2840', '#48405e', '#7a7098'],
  moss: ['#1a2a12', '#2e4a1e', '#4a6e2a', '#74963c', '#a8c060'],
  water: ['#0e2a4a', '#1a5a8a', '#3a90c0', '#7ac4e4', '#c8f0fc'],
  bark: ['#1e120c', '#3e2618', '#5e3c24', '#845a36', '#ac8050'],
  lava: ['#3a0a0a', '#8a1a0e', '#e04a14', '#ff9a2a', '#ffe680'],
  basalt: ['#0e0a12', '#221a24', '#3a2c38', '#5a4450', '#806672'],
  teal: ['#0a2a2e', '#14505a', '#1f7e84', '#4ab4ae', '#9ae6d8'],
  bone: ['#4a4038', '#8e8270', '#c8bca4', '#ece2cc', '#fffaf0'],
  rose: ['#5a1a2a', '#a03a4e', '#d8687a', '#f4a2a8', '#ffdcd8'],
  sky: ['#1a3a6a', '#3a6eb0', '#6aa6e0', '#a8d6f6', '#e8f8ff'],
  storm: ['#1a1440', '#3a2c7a', '#6a52c0', '#a88cf0', '#e8d8ff'],
  // map props
  pine: ['#0a1c1a', '#16362e', '#245244', '#3a7458', '#6a9e72'],
  snowCap: ['#3a4470', '#8a98c8', '#d0daf0', '#f0f4fc', '#ffffff'],
  runeGlow: ['#0e3a52', '#1a7a9a', '#3ac4d8', '#8af0f0', '#e8ffff'],
} as const satisfies Record<string, Ramp>;

export const INK = '#120d1c';
